import React from 'react';
import StaticPageTemplate from '../components/ui/StaticPageTemplate';
import PDFLink from '../components/ui/PDFLink';
import styled from 'styled-components';
import { privacyPageQuery } from '../queries';

const SectionTitle = styled.h2`
  color: #2E5984;
  margin-bottom: 1.5rem;
  font-size: 1.8rem;
`;

const Paragraph = styled.p`
  margin-bottom: 1rem;
  line-height: 1.6;
  white-space: pre-line;
`;

const PDFSection = styled.div`
  margin-top: 2rem;
  padding: 1.5rem;
  background-color: #f5f7fa;
  border-radius: 8px;
`;

const Privacy = () => {
  const defaultData = {
    title: "Privacy Policy",
    subtitle: "How we protect your information",
    introText: "Our privacy policy is available in PDF format below."
  };

  const customContent = (pageData) => (
    <>
      {pageData?.contentText && (
        <Paragraph>{pageData.contentText}</Paragraph>
      )}

      {/* Privacy Policy Document Section */}
      <PDFSection>
        <SectionTitle>Privacy Policy Document</SectionTitle>
        {pageData?.policyDocumentText && (
          <Paragraph>{pageData.policyDocumentText}</Paragraph>
        )}
        
        <PDFLink
          title="Tandara Privacy Policy"
          description="Complete privacy policy document outlining how we handle your personal information"
          pdfUrl={pageData?.policyDocumentUrl || "/src/assets/pdfs/TandaraPrivacyPolicy.pdf"}
        />
      </PDFSection>
    </>
  );

  return (
    <StaticPageTemplate
      pageName="privacyPage"
      query={privacyPageQuery}
      defaultData={defaultData}
      customContent={customContent}
    />
  );
};

export default Privacy;
